import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <div className="flex-1 flex flex-col items-center justify-center px-6 text-center relative overflow-hidden">
        {/* Número 404 de fundo */}
        <p className="absolute text-[18rem] md:text-[22rem] font-black text-gray-50 select-none pointer-events-none leading-none z-0">
          404
        </p>

        {/* Conteúdo */}
        <div className="relative z-10 flex flex-col items-center gap-6 max-w-lg">
          {/* Ícone */}
          <div className="w-20 h-20 flex items-center justify-center bg-orange-50 rounded-3xl">
            <i className="ri-map-pin-line text-[#E8610A] text-4xl"></i>
          </div>

          {/* Textos */}
          <div>
            <p className="text-[#E8610A] text-xs font-semibold uppercase tracking-widest mb-3">Página não encontrada</p>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
              Ops! Esta página não existe
            </h1>
            <p className="text-gray-500 text-base leading-relaxed">
              A página <span className="font-mono text-sm bg-gray-100 px-2 py-0.5 rounded text-gray-700">{location.pathname}</span> não foi encontrada. Ela pode ter sido removida ou o endereço está incorreto.
            </p>
          </div>

          {/* Ações */}
          <div className="flex flex-col sm:flex-row gap-3 mt-2">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-[#E8610A] text-white font-semibold px-8 py-3.5 rounded-full hover:bg-[#C4500A] transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-line"></i>
              Voltar ao início
            </Link>
            <Link
              to="/produtos"
              className="inline-flex items-center justify-center gap-2 border border-gray-200 text-gray-700 font-semibold px-8 py-3.5 rounded-full hover:border-[#E8610A] hover:text-[#E8610A] transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-sofa-line"></i>
              Ver produtos
            </Link>
          </div>

          {/* Links rápidos */}
          <div className="flex flex-wrap justify-center gap-2 mt-2">
            {[
              { label: 'Cadeiras', path: '/cadeiras' },
              { label: 'Mesas', path: '/mesas' },
              { label: 'Cabines Acústicas', path: '/cabines-acusticas' },
              { label: 'Divisórias', path: '/divisorias' },
              { label: 'Contato', path: '/contato' },
            ].map(link => (
              <Link
                key={link.path}
                to={link.path}
                className="text-xs text-gray-500 bg-gray-50 hover:bg-orange-50 hover:text-[#E8610A] px-4 py-2 rounded-full transition-colors duration-200 cursor-pointer border border-gray-100"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}